import React from 'react';

export interface BlockTitleProps {
    children: any;
}

const BlockTitle = ({children}: BlockTitleProps) => {
    return (
        <div className={'block-title'}>
            {children}
        </div>
    )
}

export default BlockTitle;
